import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { isAdmin, isSupervisor } from "utils/utils";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ExpenseNavigationTabs = ({ children }) => {
	const location = useLocation();
	const { t } = useTranslation();
	const canSupervise = isAdmin() || isSupervisor();

	const handleActiveClick = (e, isActive) => {
		if (isActive) {
			e.preventDefault();
		}
	};

	return (
		<div className="navigation-tabs-container">
			<Nav variant="tabs" className="navigation-tabs">
				<Nav.Item>
					<NavLink
						to="/expenses"
						className="nav-link"
						activeClassName="active disabled-link"
						onClick={(e) =>
							handleActiveClick(e, location.pathname === "/expenses")
						}
					>
						{isAdmin() || isSupervisor() ? t("expenses.title") : t("sidebar.myExpenses")}
					</NavLink>
				</Nav.Item>

				{canSupervise && (
					<>
						<Nav.Item>
							<NavLink
								to="/pending-expenses"
								className="nav-link"
								activeClassName="active disabled-link"
								onClick={(e) =>
									handleActiveClick(
										e,
										location.pathname === "/pending-expenses"
									)
								}
							>
								{t("expenses.pending.title")}
							</NavLink>
						</Nav.Item>
						<Nav.Item>
							<NavLink
								to="/approved-expenses"
								className="nav-link"
								activeClassName="active disabled-link"
								onClick={(e) =>
									handleActiveClick(
										e,
										location.pathname === "/approved-expenses"
									)
								}
							>
								{t("expenses.approved.title")}
							</NavLink>
						</Nav.Item>
					</>
				)}

				<Nav.Item>
					<NavLink
						to="/expense-groupings"
						className="nav-link"
						activeClassName="active disabled-link"
						onClick={(e) =>
							handleActiveClick(e, location.pathname === "/expense-groupings")
						}
					>
						{t("expenseGroupings.tabLabel")}
					</NavLink>
				</Nav.Item>
			</Nav>
			{children && <div className="tabs-actions">{children}</div>}
		</div>
	);
};

export default ExpenseNavigationTabs;
